import builder from '../builder';
import Maps from '../../streamline-icons/light/maps.svg';

export default builder('IconMapsLight', Maps);
